export enum HostID {
    AB = 'ab',
    BB = 'bb',
    BI = 'bi',
    BR = 'br',
    MH = 'mh',
    RW = 'rw',
    SC = 'sc',
    VI = 'vi',
    VN = 'vn',
    VP = 'vp',
    VPBE = 'vpbe',
    WH = 'wh',
}
